import React from "react";
import { Modal, Spinner } from "react-bootstrap";

interface LoadingModalProps {
  show: boolean;
  message: string;
}

const LoadingModal: React.FC<LoadingModalProps> = ({ show, message }) => {
  return (
    <Modal
      show={show}
      centered
      backdrop="static"
      keyboard={false}
      aria-labelledby="loading-modal-title"
    >
      <Modal.Body className="d-flex flex-column align-items-center justify-content-center gap-3 py-4">
        <Spinner animation="border" role="status" aria-label="Cargando" />
        <span id="loading-modal-title">{message}</span>
      </Modal.Body>
    </Modal>
  );
};

export default LoadingModal;
